import template from './info-window.template.html';

export class InfoWindowController {

    constructor($uibModal) {
        'ngInject';

        this.$uibModal = $uibModal;
    }

    open($event) {

        $event.stopPropagation();

        let modalInstance = this.$uibModal.open({
            templateUrl: template,
            resolve: {
                data: () => {
                    return {
                        title: this.title,
                        body: this.body
                    }
                }
            },
            controller: function($sce, data) {
                'ngInject';

                this.title = data.title;
                this.body = $sce.trustAsHtml(data.body);
            },
            controllerAs: '$ctrl'
        });

        modalInstance.result.then(() => {

        }, () => {

        });

    }

}



// WEBPACK FOOTER //
// ./src/js/components/info-window/info-window.controller.js